import axios from '../../axios/index.js'

export default{
    list(data){
        return axios.get('blacklist/list',{params:data})
    },
    assignedVendors(data){
        return axios.get('blacklist/assigned_vendors',{params:data})
    }
}